module.exports = __webpack_public_path__ + "static/img/nakazawa_02.448a3c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/nakazawa_02.png
// module id = mceB
// module chunks = 0